<template>
    <page :centered="false">
        <template #title>{{$t('pages.dashboard.service.objects.create.title')}}</template>

        <template #content-template>
            <m-stepper-object-create @lastStepSubmit="needConfirmRedirect=false" @confirm="confirm"/>
        </template>
    </page>
</template>

<script>
    import Page from "@pages/templates/page";
    import mStepperObjectCreate from "@modules/steppers/concrete/m-stepper-object-create";
    import dialogs from "@mixins/includes/_dialogs";

    export default {
        name: "dashboard-service-objects-create" ,
        components: {Page, mStepperObjectCreate},
        mixins: [dialogs],
        data: () => ({
            needConfirmRedirect: true
        }),
        async beforeRouteLeave(to, from, next) {
            if (!this.needConfirmRedirect) {
                return next();
            }
            await this.confirmRedirect(next)
        },
        methods: {
            async confirmRedirect(nextFn){
                let confirmed = await this.openDialog('cancelObject')
                if(!confirmed) return ;
                this.needConfirmRedirect = false
                nextFn()
            },
            confirm(confirm) {
                this.needConfirmRedirect = confirm;
            }
        },
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.service.objects.create.meta.title')
            }
        },
    }
</script>

<style scoped>

</style>
